import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import formServices from 'services/form-builder-services'
import toast from 'react-hot-toast'
import textServices from 'services/text-services'
import { Label } from 'theme/theme'
import Password from 'components/password'
import { usePopupContext } from 'hooks/use-main-cass'

interface IProps {
  onSubmit: (newPassword: string) => Promise<void>
}

const ResetPasswordV2 = ({ onSubmit }: IProps) => {
  const { closePopup } = usePopupContext()
  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(formServices.formGenerateSchema(["password", "password_confirm"])),
    criteriaMode: 'firstError',
    reValidateMode: 'onSubmit',
    mode: 'all'
  })

  function onFormSubmit(data: any) {
    onSubmit(data.password)
  }

  const onInvalid = (errors: Record<string, any>) => {
    if (errors) {
      const errorsKeys = Object.values(errors)
      toast.error(errorsKeys[0]?.message, { className: 'toast__error' })
    }
  };

  return (
    <div className="pb-4">
      <h2 className="form__sign-in__title">Resetear contraseña</h2>
      <form onSubmit={handleSubmit(onFormSubmit, onInvalid)} className='space-y-4'>
        <div className={`gap-2 flex flex-col input-container ${errors?.password?.message ? 'error-input' : ''}`}>
          <Label className="text-start text-2xl font-bold uppercase input-label">{textServices.findByText('password/label/newPassword', { es: 'Contraseña nueva', en: 'New password' })}</Label>
          <Password
            className="text-center saira font-bold text-sm"
            type="password"
            placeholder="**********"
            name="password"
            {...register("password")}
          />
        </div>
        <div className={`gap-2 flex flex-col input-container ${errors?.password_confirm?.message ? 'error-input' : ''}`}>
          <Label className="text-start text-2xl font-bold uppercase input-label">{textServices.findByText('password/label/newPasswordConfirm', { es: 'Confirmar contraseña nueva', en: 'Confirm new password' })}</Label>
          <Password
            className="text-center saira font-bold text-sm"
            type="password"
            placeholder="**********"
            name="password_confirm"
            {...register("password_confirm")}
          />
        </div>
        <div className='space-y-2'>
          <button type="submit" className="form__sign-in__btn form__sign-in__btn__main">
            Confirmar
          </button>
          <button
            type='button'
            className="form__sign-in__btn form__sign-in__btn__variant mt-2"
            onClick={closePopup}
          >
            Volver a ingresar
          </button>
        </div>
      </form>
    </div>
  )
}

export default ResetPasswordV2
